import React from 'react';
import Icon from '../../../components/AppIcon';

const TripMetadata = ({ trip }) => {
  return (
    <div className="bg-card border border-border rounded-organic p-6 shadow-organic">
      <h3 className="font-heading font-heading-semibold text-lg text-card-foreground mb-4">
        Trip Information
      </h3>

      <div className="space-y-4">
        <div className="flex items-start space-x-3">
          <Icon name="User" size={18} color="var(--color-muted-foreground)" />
          <div className="flex-1">
            <p className="font-caption text-xs text-muted-foreground">Created By</p>
            <p className="font-body text-sm text-card-foreground">{trip?.createdBy}</p>
          </div>
        </div>

        <div className="flex items-start space-x-3">
          <Icon name="Calendar" size={18} color="var(--color-muted-foreground)" />
          <div className="flex-1">
            <p className="font-caption text-xs text-muted-foreground">Created</p>
            <p className="font-body text-sm text-card-foreground">{trip?.createdAt}</p>
          </div>
        </div>

        <div className="flex items-start space-x-3">
          <Icon name="Clock" size={18} color="var(--color-muted-foreground)" />
          <div className="flex-1">
            <p className="font-caption text-xs text-muted-foreground">Last Modified</p>
            <p className="font-body text-sm text-card-foreground">{trip?.lastModified}</p>
          </div>
        </div>

        <div className="flex items-start space-x-3">
          <Icon name="MapPin" size={18} color="var(--color-muted-foreground)" />
          <div className="flex-1">
            <p className="font-caption text-xs text-muted-foreground">Primary Park</p>
            <p className="font-body text-sm text-card-foreground">{trip?.primaryPark}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TripMetadata;